import React from 'react';

import Hero from './components/Hero';
import ContactIntro from './components/ContactIntro';


export default class extends React.Component {

  render() {
    document.title = "Artikelen - Peter van der Meer - Ik maak LinkedIn gemakkelijk. - Ghostin.nl";
    return (
      <div>

        <Hero
          h1split1="Word "
          h1split2="Thought Leader."
          h2 = "Artikelen kunnen gebruikt worden als nieuwsbrieven, deze zorgen direct voor meer binding met jouw bestaande netwerk. Abonnees krijgen bij iedere editie een melding en een e-mail."
        />

        <div className="full big black">
          <div className="wrap content-block">
            <h2 style={{marginBottom:".3em"}}>Pakketten</h2>
            <div className="col-2" style={{margin:"0 auto", display:"block"}}>
              <h3 style={{marginTop:"0"}}>Deze pakketten zijn alleen beschikbaar voor bestaande klanten.<br/><br/>Iedere samenwerking is direct weer opzegbaar, maar zonder terugbetaling. Betaling gaat vooraf iedere periode, werkzaamheden worden gepland zodra de betaling ontvangen is.<br/><br/>Er is ook een bonus beschikbaar van 1 extra LinkedIn Artikel per 4 weken, als je 6x vier weken afneemt.<br/><br/>De 6x vier weken periode wordt volledig van tevoren gefactureerd. Hierbij ben je wel beschermd tegen mogelijke prijsverhogingen.</h3>
            </div>

            <div className="col-3" style={{marginTop:"2em"}}>
              <div style={{background:"#116CB2", color:"#fff", textAlign:"center", padding:".2em", borderRadius:"5px", boxShadow:"3px 3px black"}}>AANBEVOLEN</div>
              <div className="card more-rounded"style={{background:"#116CB2", color:"#fff"}}>
                <h3 style={{textAlign:"center", marginTop:"1em"}}>Thought Leader</h3>
                <p style={{marginBottom:"1em"}}>Ideaal voor serieuze "Thought Leaders" en ondernemers die hun niche willen domineren en een consistente pijplijn willen opbouwen.</p>
                <p style={{fontWeight:"bold"}}>Iedere vier weken:</p>
                <ul style={{listStyleType:"square", paddingLeft:"1.1em", fontWeight:"bold", fontSize:"1.3em"}}>
                  <li>4 artikelen/nieuwsbrieven per vier weken</li>
                  <li>Hoogste prioriteit in planning en aanpassingen</li>
                </ul>
                <div style={{fontSize:"1.2em"}}>
                  <p style={{marginTop:"1em"}}>Perfect voor: snelgroeiende startup founders, top coaches, en drukbezette leidinggevenden.</p>
                  <p style={{marginTop:"1em",fontSize:"85%"}}><span style={{color:"#F2AA22"}}>3225</span> per vier weken</p>
                </div>
              </div>
            </div>
            <div className="col-3" style={{marginTop:"2em"}}>
              <div style={{background:"#0DAA99", color:"#fff", textAlign:"center", padding:".2em", borderRadius:"5px", boxShadow:"3px 3px black"}}>POPULAIR</div>
              <div className="card more-rounded card-black">
                <h3 style={{textAlign:"center", marginTop:"1em"}}>Expert Ontwikkeling</h3>
                <p style={{marginBottom:"1em"}}>Ideaal voor ervaren experts en ondernemers die momentum willen opbouwen, en een vertrouwde stem willen worden.</p>
                <p style={{fontWeight:"bold"}}>Iedere vier weken:</p>
                <ul style={{listStyleType:"square", paddingLeft:"1.1em", fontWeight:"bold", fontSize:"1.3em"}}>
                  <li>2 artikelen/nieuwsbrieven per vier weken</li>
                  <li>Prioriteit in planning en aanpassingen</li>
                </ul>
                <div style={{fontSize:"1.2em"}}>
                  <p style={{marginTop:"1em"}}>Perfect voor: ondernemers, consultants, coaches, en leidinggevenden die aan "Thought Leadership" willen bouwen.</p>
                  <p style={{marginTop:"1em",fontSize:"85%"}}><span style={{color:"#8bc34a"}}>1650</span> per vier weken</p>
                </div>
              </div>
            </div>
            <div className="col-3" style={{marginTop:"2em"}}>
              <div style={{background:"#F2AA22", color:"#fff", textAlign:"center", padding:".2em", borderRadius:"5px", boxShadow:"3px 3px black"}}>START NU</div>
              <div className="card more-rounded card-black">
                <h3 style={{textAlign:"center", marginTop:"1em"}}>De Basis</h3>
                <p style={{marginBottom:"1em"}}>Ideaal voor drukke professionals die een consistente aanwezigheid willen zonder grote tijdsinvestering.</p>
                <p style={{fontWeight:"bold"}}>Iedere vier weken:</p>
                <ul style={{listStyleType:"square", paddingLeft:"1.1em", fontWeight:"bold", fontSize:"1.3em"}}>
                  <li>1 artikel/nieuwsbrief per vier weken</li>
                </ul>
                <div style={{fontSize:"1.2em"}}>
                  <p style={{marginTop:"1em"}}>Perfect voor: startende ondernemers en solo professionals.</p>
                  <p style={{marginTop:"1em",fontSize:"85%"}}><span style={{color:"#8bc34a"}}>900</span> per vier weken</p>
                </div>
              </div>
            </div>
            <small style={{marginBottom:".3em", marginTop:"1em", opacity:".5", display:"block", fontSize:"75%", textAlign:"right"}}>prijzen zijn exclusief 21% BTW.</small>

          </div>
        </div>

        <ContactIntro />

      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/ServicesArticles.js